/*
 * Request for Quote app - button integration.
 *
 * Two fixes, both driven off the same observer because the app renders lazily
 * (the theme's loadJSscripts defers third-party scripts until the first user interaction).
 *
 * 1. Collection / slider cards - the app injects its button (.rfq-collection-btn) plus a
 *    hidden variant input as siblings of .grid-view-item, which lands underneath the card.
 *    The product tile design puts that button beside "Add to Cart", so we move the app's own
 *    button into the card's .pd-actions row and drop the theme's fallback link. The app keeps
 *    ownership of the quote logic - we only reposition and restyle its button. If the app
 *    never renders a button, the fallback link to the product page stays in place.
 *
 * 2. Product page - the app builds its button by cloning the theme's "Buy Now" button, so the
 *    clone renders reading "Buy Now" until the app's script gets around to relabelling it
 *    (measured at roughly 4.7s on a cold load). We set the label as soon as the button appears
 *    so it never shows the wrong one. The app is still free to overwrite it afterwards, so a
 *    label configured in the app's settings wins - we only fill the gap.
 */
(function () {
  var PLACED = 'data-pd-placed';
  var LABELLED = 'data-pd-labelled';
  var QUOTE_LABEL = 'Add to Quote';
  var scheduled = false;

  // 1. Move the app's card button into the tile's action row.
  function placeQuoteButtons() {
    var buttons = document.querySelectorAll('.rfq-collection-btn:not([' + PLACED + '])');

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var item = btn.closest ? btn.closest('.grid__item, .rfq-collection-item') : null;
      if (!item) continue;

      var actions = item.querySelector('.pd-actions');
      if (!actions) continue;

      btn.setAttribute(PLACED, '');
      btn.classList.add('pd-btn', 'pd-btn--quote');
      actions.appendChild(btn);

      // The app reads the variant id from this hidden input - keep it with the button.
      var variantInput = item.querySelector('input.rfq-variant-id');
      if (variantInput) actions.appendChild(variantInput);

      var fallback = actions.querySelector('.pd-btn--quote-fallback');
      if (fallback) fallback.parentNode.removeChild(fallback);
    }
  }

  // 2. Stop the product page button from showing the cloned "Buy Now" label first.
  function labelProductQuoteButton() {
    var buttons = document.querySelectorAll(
      '.rfq-btn:not(.rfq-collection-btn):not([' + LABELLED + '])'
    );

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      // The clone carries a copy of the theme's own label span, id and all.
      var label = btn.querySelector('[id^="AddToCartText-"]');
      if (!label) continue;

      btn.setAttribute(LABELLED, '');
      if (label.textContent.trim() !== QUOTE_LABEL) label.textContent = QUOTE_LABEL;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      placeQuoteButtons();
    }, 50);
  }

  // Relabelling runs synchronously so it lands in the same frame the app inserts the
  // button - a debounce here would let the wrong label paint first. Moving the card
  // buttons stays debounced; it is heavier and a frame late costs nothing.
  function onMutations() {
    labelProductQuoteButton();
    schedule();
  }

  document.documentElement.classList.add('pd-quote-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onMutations);
  } else {
    onMutations();
  }

  // The app renders its buttons lazily, and filtering/pagination re-renders the grid.
  if (window.MutationObserver) {
    new MutationObserver(onMutations).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
